import { FormControl, TextField } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

const InputText = React.forwardRef(({
    control,
    name,
    label,
    defaultValue,
    rules,
    variant = 'outlined',
    margin = 'dense',
    type = "",
    disabled = false, // Add disabled prop with default value
    readOnly = false, // Add readOnly prop with default value
    onChange,
    ...props
}, ref) => {
    return (
        <FormControl fullWidth variant={variant} margin={margin}>
            <Controller
                {...props}
                name={name}
                control={control}
                rules={rules}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        label={label}
                        type={type}
                        defaultValue={defaultValue || ""}
                        margin={margin}
                        variant={variant}
                        InputLabelProps={{ shrink: true }}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                        inputRef={ref}
                        fullWidth
                        disabled={disabled}  // Pass disabled prop
                        InputProps={{ readOnly: readOnly }} // Pass readOnly prop
                        onChange={(e) => {
                            field.onChange(e); // This updates the react-hook-form state
                            if (onChange) onChange(e); // Custom onChange handler
                        }}
                    />
                )}
            />
        </FormControl>
    );
});

export default InputText;
